import React from 'react';
import { CSSProperties } from 'react';

interface RemoteProps {
  counter: number; // Counter prop
}

const RemoteComponent: React.FC<RemoteProps> = ({ counter }) => {
  const isButtonLit = (button: string): boolean => {
    switch (button) {
      case 'power':
        return counter >= 15;
      case 'volumeUp':
        return counter >= 3;
      case 'volumeDown':
        return counter >= 4;
      case 'channelUp':
        return counter >= 1;
      case 'channelDown':
        return counter >= 2;
      default:
        return false;
    }
  };

  return (
    <div style={styles.remoteContainer}>
      <div style={styles.remoteBack}>
        {/* Power Button */}
        <div
          style={{
            ...styles.powerButton,
            background: isButtonLit('power')
              ? 'linear-gradient(rgb(255, 0, 0), rgb(128, 0, 0))'
              : 'linear-gradient(rgb(40, 40, 40), rgb(83, 83, 83))',
          }}
        />

        {/* Other Buttons (Channel & Volume) */}
        <div style={styles.otherButtons}>
          {/* Channel Buttons */}
          <div style={styles.channelButtons}>
            <div
              style={{
                ...styles.button,
                background: isButtonLit('channelUp')
                  ? 'linear-gradient(rgb(255, 183, 0), rgb(171, 137, 0))'
                  : 'linear-gradient(rgb(40, 40, 40), rgb(83, 83, 83))',
              }}
            />
            <div
              style={{
                ...styles.button,
                background: isButtonLit('channelDown')
                  ? 'linear-gradient(rgb(255, 183, 0), rgb(171, 137, 0))'
                  : 'linear-gradient(rgb(40, 40, 40), rgb(83, 83, 83))',
                marginTop: '30px',
              }}
            />
          </div>

          {/* Volume Buttons */}
          <div style={styles.volumeButtons}>
            <div
              style={{
                ...styles.button,
                background: isButtonLit('volumeUp')
                  ? 'linear-gradient(rgb(0, 158, 47), rgb(0, 42, 10))'
                  : 'linear-gradient(rgb(40, 40, 40), rgb(83, 83, 83))',
              }}
            />
            <div
              style={{
                ...styles.button,
                background: isButtonLit('volumeDown')
                  ? 'linear-gradient(rgb(0, 158, 47), rgb(0, 42, 10))'
                  : 'linear-gradient(rgb(40, 40, 40), rgb(83, 83, 83))',
                marginTop: '30px',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  remoteContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '50px',
  },
  remoteBack: {
    background: 'rgba(26, 26, 33, 1)',
    width: '200px',
    height: '350px',
    borderRadius: '30px',
    padding: '10px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
  },
  powerButton: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    margin: '0 auto',
    marginTop: '20px',
    transition: 'background-color 0.3s',
  },
  otherButtons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '30%',
  },
  channelButtons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  volumeButtons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  button: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    margin: '0 auto',
    transition: 'background-color 0.3s',
  },
};

export default RemoteComponent;
